<template>
  <div class="add-professor">
    <Card>
      <h2 v-if="!proInfo.id" style="text-align: center;margin:20px 0 0 0;">新增应急专家</h2>
      <h2 v-else style="text-align: center;margin:20px 0 0 0;">修改应急专家</h2>
      <Divider/>
      <div style="width: 70%;margin: 0 auto">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
          <FormItem label="专家姓名" prop="name">
            <Input v-model="formValidate.name" placeholder="请填写专家姓名"></Input>
          </FormItem>
          <FormItem label="身份证号" prop="idCard">
            <Input v-model="formValidate.idCard" placeholder="请填写身份证号"></Input>
          </FormItem>
          <FormItem label="性别" prop="sex">
            <Select v-model="formValidate.sex">
              <Option :value="0">女</Option>
              <Option :value="1">男</Option>
            </Select>
          </FormItem>
          <FormItem label="手机" prop="phone">
            <Input v-model="formValidate.phone" placeholder="请填写手机"></Input>
          </FormItem>
          <FormItem label="专业类别" prop="professionType">
            <TreeSelect class="treeSelect" transfer clearable v-model="formValidate.professionType"
                        :data="expertiseList"/>
            <!--            <Select v-model="formValidate.professionType" placeholder="请选择专业类别">-->
            <!--              <OptionGroup v-for="(item, index) in expertiseList" :label="item.expertise.name">-->
            <!--                <Option v-for="item in item.children" :value="item.value" :key="item.value">{{ item.value }}</Option>-->
            <!--              </OptionGroup>-->
            <!--            </Select>-->
          </FormItem>
          <FormItem label="专家级别" prop="specialistLevel">
            <Select v-model="formValidate.specialistLevel" placeholder="请选择专家级别">
              <Option :value="1">国家级专家</Option>
              <Option :value="2">省级专家</Option>
              <Option :value="3">市级专家</Option>
              <Option :value="4">县区级专家</Option>
            </Select>
          </FormItem>
          <FormItem label="最高学历" prop="highestDegree">
            <Select v-model="formValidate.highestDegree" placeholder="请选择最高学历">
              <Option :value="1">高中</Option>
              <Option :value="2">大专</Option>
              <Option :value="3">学士</Option>
              <Option :value="4">硕士</Option>
              <Option :value="5">博士</Option>
              <Option :value="6">博士后</Option>
            </Select>
          </FormItem>
          <FormItem label="行政区域" prop="responsibleAreaId">
            <Row :gutter="4">
              <Col :span="10">
                <FormItem>
                  <Select transfer clearable :disabled="countryList.length === 1" v-model="formValidate.responsibleAreaId" @on-change="getStreeByCountryId"
                          placeholder="区县">
                    <Option v-for="(item) in countryList" :key="item.id" :value="item.indexCode">{{ item.name }}
                    </Option>
                  </Select>
                </FormItem>
              </Col>
              <!--              <Col :span="10">-->
              <!--                <FormItem prop="responsibleStreetId">-->
              <!--                  <Select transfer clearable v-model="formValidate.responsibleStreetId" placeholder="街道">-->
              <!--                    <Option v-for="(item) in streetList" :key="item.id" :value="item.id">{{ item.name }}</Option>-->
              <!--                  </Select>-->
              <!--                </FormItem>-->
              <!--              </Col>-->
            </Row>
          </FormItem>
          <FormItem label="住址" prop="address">
            <Input v-model="formValidate.address" placeholder="请填写住址"></Input>
          </FormItem>
          <FormItem label="经纬度" prop="longitude">
            <Row :gutter="4">
              <Col :span="3">
                <Button type="primary" @click="getLocationByMap">定位</Button>
              </Col>
              <Col :span="8">
                <FormItem prop="longitude">
                  <Input v-model="formValidate.longitude" placeholder="请填写经度"></Input>
                </FormItem>
              </Col>
              <Col :span="8">
                <FormItem prop="dimension">
                  <Input v-model="formValidate.dimension" placeholder="请填写纬度"></Input>
                </FormItem>
              </Col>
            </Row>
          </FormItem>
          <FormItem label="工作单位" prop="workUnit">
            <Input v-model="formValidate.workUnit" placeholder="请填写工作单位"></Input>
          </FormItem>
          <FormItem label="适用事件类型" prop="applicableEventTypes">
            <Select transfer v-model="formValidate.applicableEventTypes" placeholder="请选择适用事件类型">
              <Option v-for="(item, index) in eventList" :value="item.id" :key="index">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="备注" prop="remark">
            <Input v-model="formValidate.remark" type="textarea" :autosize="{minRows: 5}"/>
          </FormItem>
          <FormItem label="附件" prop="annex">
            <!--            <Input v-model="formValidate.annex" type="textarea"/>-->
            <Upload
                :headers="annexHeaders"
                :show-upload-list="false"
                :on-success="annexSuccess"
                :action="$uploadUrl+'/api/file/upload'">
              <Button icon="ios-cloud-upload-outline">上传附件</Button>
            </Upload>
            <span v-if="formValidate.annex !== ''">
                          {{ formValidate.annex }}
                          <Icon type="md-close"
                                @click="delAnnexFilePath"
                                style="float: right;margin-right: 30px;line-height: 30px"/>
                        </span>
          </FormItem>
          <FormItem label="照片" prop="picture">
            <!--            <Input v-model="formValidate.picture" type="textarea"/>-->
            <Upload
                :headers="pictureHeaders"
                :show-upload-list="false"
                :on-success="pictureSuccess"
                :action="$uploadUrl+'/api/file/upload'">
              <Button icon="ios-cloud-upload-outline">上传照片</Button>
            </Upload>
            <span v-if="formValidate.picture !== ''">
                          {{ formValidate.picture }}
                          <Icon type="md-close"
                                @click="delPictureFilePath"
                                style="float: right;margin-right: 30px;line-height: 30px"/>
                        </span>
          </FormItem>
          <!--          <FormItem>-->
          <!--            <Button v-if="!proInfo.id" type="primary" @click="handleSubmit('formValidate')">新增</Button>-->
          <!--            <Button v-if="proInfo.id" type="primary" @click="editTeam('formValidate')">编辑</Button>-->
          <!--            <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>-->
          <!--          </FormItem>-->
        </Form>
        <div style="text-align: center">
          <Button v-if="!proInfo.id" type="primary" :loading="saveLoading" @click="handleSubmit('formValidate')">新增
          </Button>
          <Button v-if="proInfo.id" type="primary" :loading="saveLoading" @click="editTeam('formValidate')">编辑
          </Button>
          <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>
          <Button @click="goBack" type="primary" style="margin-left: 8px">返回</Button>
        </div>
      </div>
    </Card>

    <Modal
        v-model="modal"
        title="地图"
        @on-ok="ok"
        @on-cancel="cancel">
      <div style="margin-bottom: 10px">
        <AutoComplete
            transfer
            clearable
            v-model="searchPlace"
            @on-search="handleSearch"
            placeholder="请输入搜索地址"
            style="width:200px">
          <Option v-for="item in searchList" :value="item.title" :key="item.uid">{{ item.title }}</Option>
        </AutoComplete>
        <Button type="primary" @click="getLocal">搜索</Button>
      </div>

      <div id="map" style="width: 100%;height: 400px"></div>
    </Modal>
  </div>
</template>

<script>
import { BMapLoader } from '@/utils/mapLoader'

export default {
  name: "addEmProfessor",
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('必填'))
      } else if (!/^1[3456789]\d{9}$/.test(value)) { // 判断用户输入的值是否符合规则
        callback(new Error('请输入正确的11位手机号码'))
      } else {
        callback()
      }
    }
    return {
      saveLoading: false,
      annexHeaders: { Authorization: localStorage.getItem('token') },
      pictureHeaders: { Authorization: localStorage.getItem('token') },
      searchPlace: '',
      searchList: [],
      modal: false,
      eventList: [],
      expertiseList: [],
      proInfo: {},
      streetList: [],
      countryList: [],
      formValidate: {
        name: '',
        idCard: '',
        personInCharge: '',
        personInChargePhone: '',
        phone: '',
        professionType: '',
        specialistLevel: null,//1国家级专家2省级专家3市级专家4县区级专家
        sex: '',
        highestDegree: '',
        establishedTime: '',
        responsibleAreaId: '',
        responsibleStreetId: '',
        address: '',
        longitude: '',
        dimension: '',
        workUnit: '',
        applicableEventTypes: 1,
        superviseLevel: 1,//1-市级，2-区县级，3-镇街级
        introduce: '',
        remark: '',
        annex: '',
        picture: ''
      },
      ruleValidate: {
        name: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'change' }
        ],
        professionType: [
          { transform: (value) => String(value), required: true, message: '必填', trigger: 'blur' }
        ],
        specialistLevel: [
          { transform: (value) => String(value), required: true, message: '必填', trigger: 'blur' }
        ],
        sex: [
          { transform: (value) => String(value), required: true, message: '必填', trigger: 'blur' }
        ],
        highestDegree: [
          { transform: (value) => String(value), required: true, message: '必填', trigger: 'blur' }
        ],
        establishedTime: [
          { required: true, type: 'date', message: '必填', trigger: 'blur' }
        ],
        responsibleAreaId: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        responsibleStreetId: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        longitude: [
          { transform: (value) => String(value), required: true, message: '必填', trigger: 'blur' }
        ],
        dimension: [
          { transform: (value) => String(value), required: true, message: '必填', trigger: 'blur' }
        ],
        workUnit: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        applicableEventTypes: [
          { transform: (value) => String(value), required: true, message: '必填', trigger: 'blur' }
        ],
        superviseLevel: [
          { transform: (value) => String(value), required: true, message: '必填', trigger: 'blur' }
        ],
        introduce: [
          { required: true, message: '必填', trigger: 'blur' }
        ],
        remark: [
          { required: false, message: '必填', trigger: 'blur' }
        ],
        annex: [
          { required: false, message: '必填', trigger: 'blur' }
        ],
        picture: [
          { required: false, message: '必填', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.getAllEvents()
    this.getExpertise()
    this.getCountry()
    if (this.$route.params.row) {
      this.proInfo = this.$route.params.row.specialist
      this.proInfo.applicableEventTypes = this.proInfo.applicableEventTypes.toString()
      this.proInfo.responsibleAreaId = this.proInfo.responsibleAreaId.toString()
      this.getStreeByCountryId(this.proInfo.responsibleAreaId)
      this.proInfo.responsibleStreetId = this.proInfo.responsibleStreetId.toString()
      this.proInfo.professionType = Number(this.proInfo.professionType)
      this.proInfo.sex = this.proInfo.sex ? 1 : 0
      this.formValidate = this.proInfo
    }
  },
  methods: {
    goBack(){
      // 跳转关闭当前页
      this.$store.commit('app/closePage', {
        vm: this,
        fromName: this.$route.name,
        toName: 'emergencyProfessor'
      })
    },
    annexSuccess(response, file, fileList) {
      console.log(response, file, fileList)
      this.formValidate.annex = file.response
      this.uploading = false
    },
    annexBeforeUpload() {
      this.uploading = true
    },
    delAnnexFilePath() {
      this.formValidate.annex = ''
    },
    pictureSuccess(response, file, fileList) {
      console.log(response, file, fileList)
      this.formValidate.picture = file.response
      this.uploading = false
    },
    pictureBeforeUpload() {
      this.uploading = true
    },
    delPictureFilePath() {
      this.formValidate.picture = ''
    },
    ok() {
      this.formValidate.longitude = this.local[0].point.lat
      this.formValidate.dimension = this.local[0].point.lng
    },
    cancel() {
    },
    handleSearch(str) {
      setTimeout(() => {
        const _this = this
        var options = {
          onSearchComplete: function (res) { //检索完成后的回调函数
            var s = [];
            if (local.getStatus() == BMAP_STATUS_SUCCESS) {
              for (var i = 0; i < res.getCurrentNumPois(); i++) {
                s.push(res.getPoi(i));
              }
              // console.log(s)
              _this.searchList = s
            } else {
              _this.searchList = s
            }
          }
        }
        var local = new _this.BMap.LocalSearch(_this.map, options) //创建LocalSearch构造函数
        local.search(str) //调用search方法，根据检索词str发起检索
      }, 1000)
    },
    getLocal() {
      console.log(this.searchPlace)
      this.local = this.searchList.filter(item => item.title === this.searchPlace && item.type === 0)
      console.log(this.local)
      if (this.local.length > 0) {
        for (var i = 0; i < this.local.length; i++) {
          var lat = this.local[i].point.lat // 经度
          var lng = this.local[i].point.lng // 纬度
          var point = new this.BMap.Point(lng, lat)
          var marker = new this.BMap.Marker(point)
          this.map.addOverlay(marker);
          this.map.centerAndZoom(point, 16)
        }
      }
    },
    initBMap() {
      BMapLoader(this.$mapConfigKey).then(BMap => {
        const map = new BMap.Map('map', { enableMapClick: false })
        this.map = map
        this.BMap = BMap
        map.disableKeyboard() // 禁用键盘操作地图
        map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放
        // 添加中心点和缩放等级，如果不添加，初始化出来页面为白屏
        const point = new BMap.Point(116.36555, 37.44131)
        map.centerAndZoom('德州市', 12)
        // var marker = new BMap.Marker(point)
        // this.Map.addOverlay(marker);
      })
    },
    getLocationByMap() {
      this.modal = true
      this.initBMap()
    },
    //区县
    getCountry() {
      this.$http.get('/api/getLowerLevelDepts?flag=4').then(res => {
        console.log(res)
        this.countryList = res.data
        if (this.countryList.length === 1) {
          this.formValidate.responsibleAreaId = res.data[0].indexCode
        }
      })
    },
    getStreeByCountryId(value) {
      this.getStreet(value)
    },
    //根据区县获取街道
    getStreet(id) {
      this.$http.get(`/api/street/${id}`).then(res => {
        console.log(res)
        this.streetList = res.data.data
      })
    },
    //获取事件类型/api/event/getAll
    getAllEvents() {
      this.$http.get('/api/event/getAll').then(res => {
        console.log(res)
        this.eventList = res.data.data
        // this.eventList = this.eventList.Map(item => item.id = Number(item.id))
      })
    },
    //获取专业类型/api/expertise/getAll
    getExpertise() {
      this.$http.get('/api/expertise/getAll').then(res => {
        console.log(res)
        this.expertiseList = res.data.data
        console.log(this.expertiseList)
      })
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.saveLoading = true
          this.$http.post('/api/specialist/specialists', this.formValidate).then(res => {
            if (res.status === 200 || res.status === 201) {
              this.$Message.success('新增完成！')
              this.saveLoading = false
              // 跳转关闭当前页
              this.$store.commit('app/closePage', {
                vm: this,
                fromName: this.$route.name,
                toName: 'emergencyProfessor'
              })
            } else {
              this.$Message.error(res.data.message)
            }
          })
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    editTeam(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.saveLoading = true
          this.$http.put('/api/specialist/specialists', this.formValidate).then(res => {
            if (res.status === 200 || res.status === 201) {
              this.$Message.success('修改完成！')
              this.saveLoading = false
              // 跳转关闭当前页
              this.$store.commit('app/closePage', {
                vm: this,
                fromName: this.$route.name,
                toName: 'emergencyProfessor'
              })
            } else {
              this.$Message.error(res.data.message)
            }
          })
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    }
  }
}
</script>

<style scoped lang="less">
.add-professor {
  .treeSelect {
    width: 200px;

    :deep(.ivu-tree) {

    }
  }
}
</style>
